<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 id="EditOrganizationDialog" mat-dialog-title appLifecycleTracker trackerName="edit-org-dialog">{{fHeader}}</h2>

<mat-dialog-content>
    <form id="registerForm" [formGroup]="form">
        <div>
            <mat-form-field appearance="outline">
                <input id="registerFormCompany" matInput type="text" formControlName="company" placeholder="{{fCompany}}" maxlength="255" />
                <mat-error *ngIf="form.controls['company'].errors?.required">{{'COMPANY_NAME_REQ' | translate}}</mat-error>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field appearance="outline">
                <input  id="registerFormContactEmail" matInput type="email" placeholder="{{'CONTACT_EMAIL' | translate}}"  formControlName="contact_email"  />
                <mat-error *ngIf="contact_email.errors?.required">{{'EMAIL_REQ' | translate}}</mat-error>
                <mat-error *ngIf="contact_email.errors?.pattern">{{'APU_EMAIL_INVALID' | translate}}</mat-error>
            </mat-form-field>
        </div>

        <div style="padding-bottom: 20px;" *ngIf="user?.org_type?.manage_child">
            <mat-checkbox class="" color="primary" formControlName="reserve_domain">{{'reserve-domain.checkbox-label' | translate}}</mat-checkbox>
        </div>

        <div style="padding-bottom: 20px;" *ngIf="data.managingGroup?.enable_endpoint_map">
            <mat-checkbox class="" color="primary" formControlName="enable_endpoint_map">{{'enable-endpoint-map.checkbox-label' | translate}}</mat-checkbox>
        </div>

        <div *ngIf="user?.org_type?.create_child && user?.partnerId == null">
            <mat-form-field appearance="outline">
                <mat-label>{{'PARTNER' | translate}}</mat-label>
                <mat-select formControlName="partnerId">
                    <mat-option value="-1">{{'ADO_SYS_DEFAULT' | translate}}</mat-option>
                    <mat-option *ngFor="let partner of partners" [value]="partner.id.toString()">
                        {{partner.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="canSetEdition">
            <mat-form-field appearance="outline">
                <mat-label>{{'SET_EDITION' | translate}} {{this.currentEdition}}</mat-label>
                <mat-select formControlName="edition">
                    <mat-option value="d3eBusiness">{{'ADS_PREMIUM' | translate}}</mat-option>
                    <mat-option [disabled]="true" value="d3ePersonal">{{'ADS_PERSONAL' | translate}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>

<div mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onCancelClick()" type="button">{{fCancel}}</button>
    <button mat-raised-button (click)="onSubmit()" [disabled]="!form.valid || checkingEmailExists" type="button" color="primary">{{fSave}}</button>
</div>
